/**
 * Query params captured on landing and persisted for the lifetime of the attribution
 * window, so paid-click attribution survives internal navigation away from the landing URL.
 */
export const searchParamKeys = [
	"gclid",
	"msclkid",
	"fbclid",
	"twclid",
	"ttclid",
	"ScCid",
	"adset_id",
	"ad_id",
	"adgroup_id",
	"utm_source",
	"utm_medium",
	"utm_campaign",
	"utm_content",
	"utm_term",
	"utm_id",
	"utm_source_platform",
	"placement",
	"keyword",
	"matchtype",
	"device",
	"creative",
	"gad_source",
	"gad_campaignid",
	"gbraid",
	"utm_campaign_id",
	"utm_adset_id",
] as const;

export type StoredClickIds = { [K in typeof searchParamKeys[number]]?: string; };
